import { TextArea } from './TextArea';

export default TextArea;
export { TextArea };
